import i18next from 'i18next'

// i18next's debug pseudo-language: it is not a real locale and must never reach a backend.
const CIMODE = 'cimode'

// Read at request time (not module load) so a language switch applies to the very next call.
// Imports the i18next singleton directly instead of `@/shared/lib/i18n/i18n` to avoid pulling
// the HTTP backend/detector bootstrapping into every API module.
export function acceptLanguageHeader(): Record<string, string> {
  const language = i18next.resolvedLanguage ?? i18next.language
  if (!language || language === CIMODE) return {}
  return { 'Accept-Language': language }
}
